module.exports = __webpack_public_path__ + "static/img/wantedLow.125d4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wantedLow.png
// module id = wHfu
// module chunks = 1 3